import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select-and-field',
  templateUrl: './select-and-field.component.html',
  styleUrls: ['./select-and-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectAndFieldComponent {
  @Input() form: FormGroup;

  @Input() inputNameTickets: string;
  @Input() inputNameType: string;
  @Input() genericPlaceholder: string;
  @Input() errorMessage: string;

  @Input() type = 'text';
  @Input() label = '';
  @Input() id = '';

  @Input() valueInput: number | string;
  @Input() valueSelect: string;

  @Input() valuesSelect: string[];

  @Input() submitted: boolean;
  @Input() disabled: boolean;
  @Input() isGenericSelectAndFieldComponent: boolean;

  @Output() valueChange = new EventEmitter<string | number>();
  @Output() addControl = new EventEmitter<string>();
  @Output() deleteControl = new EventEmitter<number>();
  @Output() tktChanged = new EventEmitter();

  inputValue = '';

  getError(): boolean {
    return (
      this.submitted && (this.form.controls.pnr.invalid || this.form.controls.ticketNumbers.invalid)
    );
  }

  showTickets(): boolean {
    return (
      (this.form &&
        this.form.controls.searchType?.value === 'tkt' &&
        this.form.controls.ticketNumbers.value.length > 0) ||
      this.isGenericSelectAndFieldComponent
    );
  }

  ontktChange(event: string) {
    this.tktChanged.emit(event);
  }
}
